import { useEffect } from 'react';

export const OneTrustConsentGroupIds = {
  necessary: 'C0001',
  performance: 'C0002',
  functional: 'C0003',
  targeting: 'C0004',
  social_media: 'C0005',
};

export const openCookiePreferences = (ev) => {
  if (window.OneTrust) {
    window.OneTrust.ToggleInfoDisplay();
  }
  ev.preventDefault();
};

export default function OneTrust() {
  useEffect(() => {
    const otAutoBlockScript = document.createElement('script');
    otAutoBlockScript.src =
      'https://cdn.cookielaw.org/consent/ab0b3f4f-ef7f-47e8-b326-53cd76b54d15/OtAutoBlock.js';
    otAutoBlockScript.async = true;
    document.head.appendChild(otAutoBlockScript);

    const otSDKStubScript = document.createElement('script');
    otSDKStubScript.src =
      'https://cdn.cookielaw.org/consent/ab0b3f4f-ef7f-47e8-b326-53cd76b54d15/otSDKStub.js';
    otSDKStubScript.setAttribute(
      'data-domain-script',
      'ab0b3f4f-ef7f-47e8-b326-53cd76b54d15'
    );
    otSDKStubScript.async = true;
    document.head.appendChild(otSDKStubScript);

    const inlineScript = document.createElement('script');
    inlineScript.text = 'function OptanonWrapper(){}';
    document.head.appendChild(inlineScript);

    return () => {
      document.head.removeChild(otAutoBlockScript);
      document.head.removeChild(otSDKStubScript);
      document.head.removeChild(inlineScript);
    };
  }, []);

  return null;
}
